import { useCurrentTenant } from "@drift/oneplatfront-components";
import { CodeViewer } from "@onefront/react-workspace-components";
import { BanksLookup, useWsGet } from "@onefront/workspace-forms";
import { ExtendedTypography } from "@vapor/react-extended";
import { Button, Grid, Stack, TextField } from "@vapor/react-material";
import { useEffect, useState } from "react";

export const BankLookupSmartDemo = () => {
    const { tenant } = useCurrentTenant(true);
    const [selectData, setSelectData] = useState<any>(null);
    const [submitData, setSubmitData] = useState<any>(null);

    return (
        <Stack width={"100%"} maxWidth={"1280px"} margin={"0 auto"} gap={3}>
            <Stack direction="row" gap={2} alignItems="center" justifyContent={"space-between"}>
                <ExtendedTypography variant="titleLarge">Banks Lookup Demo</ExtendedTypography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => window.open(`/details/${tenant?.id}/creditlines`, "_blank")}
                >
                    BANKS SECTION
                </Button>
            </Stack>
            <Grid container rowGap={2} columnGap={2} justifyContent="space-between" alignItems={"center"}>
                <Grid item xs={5}>
                    <TextField label={"Tenant Workspace ID"} value={tenant?.id} readOnly />
                </Grid>
            </Grid>
            <BanksLookup
                workspaceId={tenant?.id}
                cslId={null}
                onClear={() => {
                    setSelectData(null);
                }}
                onEdit={(data: any) => {
                    setSelectData(data);
                }}
                onSelect={(data: any) => {
                    setSelectData(data);
                }}
                onSubmit={data => {
                    setSubmitData(data);
                }}
            />
            <CodeViewer json={selectData} label="onSelect Data" display />
            <CodeViewer json={submitData} label="onSubmit Data" display />
        </Stack>
    );
};
